import React from 'react';
import { TextInputField } from 'common/components/form_fields';
import { Field } from 'redux-form';

const Form = ({ handleSubmit, submit, label }) => (
  <form onSubmit={handleSubmit}>
    <Field name="search" label={label || "Search"} component={TextInputField} />
    <i className="fa fa-search" onClick={submit} />
  </form>
)

export default Form;
